/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable max-len */
/* eslint-disable react/jsx-filename-extension */
import React from "react";

export default function Warrantypolicy() {
  return (
    <section className="hero sm:items-center lg:items-start sm:flex-row">
      <div className="w-full flex flex-col px-5 mb-5 sm:mb-0 sm:px-12 sm:mt-6 lg:mt-12 ">
        <h3 className="text-5xl text-theme-blue text-center font-bold leading-tight mb-4 dark:text-white">
          Nube iO Group Warranty
        </h3>
        <div className="my-6 w-full border-t-4 border-theme-teal mb-12" />
        <div className="space-y-6">
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Our goods and services come with guarantees that cannot be excluded
            under the Australian Consumer Law. For major failures with the
            service, you are entitled:
          </p>
          <ul className="list-inside list-disc text-base font-light text-gray-400  mb-6">
            <li>to cancel your service contract with us; and</li>
            <li>
              to a refund for the unused portion, or to compensation for its
              reduced value.
            </li>
          </ul>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            You are also entitled to choose a refund or replacement for major
            failures with goods. If a failure with the goods or a service does
            not amount to a major failure, you are entitled to have the failure
            rectified in a reasonable time. If this is not done you are entitled
            to a refund for the goods and to cancel the contract for the service
            and obtain a refund of any unused portion. You are also entitled to
            be compensated for any other reasonably foreseeable loss or damage
            from a failure in the goods or service.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            This warranty is provided in addition to your rights under the
            Australian Consumer Law or otherwise under law.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Nube iO warrants that the services we supply will be free from
            defects in material and workmanship for a period of 30 days from the
            date of performance of the service. If we do not conform to this
            warranty and you notify us of such failure within such 30 day
            period, we will at our sole discretion, either re-perform the
            services or provide you with a refund of the charges you have paid
            for those services. This is your sole and exclusive remedy.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Nube iO also warrants that its Nube iO branded products are free
            from defects in material and workmanship for a period of 12 months
            from the date of purchase stated on the purchase invoice or receipt.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            If there is any such defect in a Nube iO branded product, Nube iO
            will either repair or replace the product. Goods presented for
            repair may be replaced by refurbished goods of the same type rather
            than being repaired. Refurbished parts may be used to repair the
            goods. With respect to products that are capable of storing data
            created by you (user-generated data), repairing that product may
            result in loss of that data.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            In order for you to be entitled to claim under this warranty:
          </p>
          <ul className="list-inside list-disc text-base font-light text-gray-400 mb-6">
            <li>
              you must promptly, and within the time periods set out above,
              notify us of the defect in writing or by email using the contact
              details below; and
            </li>
            <li>
              you must return the product to us or to an authorised Nube iO
              dealer, at your cost.
            </li>
          </ul>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            You will be responsible for all costs and expenses associated with a
            warranty claim including without limitation the cost of labour for
            the replacement, removal or installation of the product.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Perishables, external accessories and batteries are excluded from
            this warranty.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            This warranty only applies if the original serial number of the
            product can be identified.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Nube iO will not be responsible for any defects or conditions caused
            by:
          </p>
          <ul className="list-inside list-disc text-base font-light text-gray-400 mb-6">
            <li>your act or omission or those of any third party;</li>
            <li>
              your failure to perform your obligations under your contract with
              us;
            </li>
            <li>
              any modification, addition or alteration to a product or service
              by you or a third party;
            </li>
            <li>
              any damage by neglect, accident, abuse, misuse or misapplication
              by you or any third party; or
            </li>
            <li>Force Majeure.</li>
          </ul>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Force Majeure means fire, storm, flood, earthquake, explosion,
            accident, acts of a public enemy, terrorist acts, war, rebellion,
            insurrection, sabotage, epidemic, quarantine restriction,
            transportation embargo, strikes and any other event which is outside
            yours or our reasonable control.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Other than the warranties set out in this warranty, we make no other
            warranties to you, expressed or implied, and we specifically
            disclaim any implied warranty of merchantability or fitness for a
            purpose and all warranties arising from a course of dealing or usage
            of trade, except as prohibited by law. We also exclude any warranty
            that software will be error free, secure from cyber threats or
            uninterrupted.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            You acknowledge the use of your own skill and expertise in the
            selection of the products and services and you do not rely on any
            oral or written statements, representations or samples made or
            presented to you at any time.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            We assume no liability for any technical advice given to you on the
            use of the products or the services.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Non–Nube iO branded products purchased from Nube iO may be eligible
            for coverage under the Australian Consumer Law but they are not
            covered by this warranty. We do not give you any warranty, expressed
            or implied, for non–Nube iO branded products. If the manufacturer of
            a non–Nube iO branded product provides an assignable warranty
            relating to that product (“Product Warranty”), we will notify you of
            the Product Warranty and assign it to you to the extent permitted by
            such Product Warranty and any applicable law. If you consider that
            any non–Nube iO branded product we supply to you is defective, you
            must notify us of the defect in accordance with the terms of the
            Product Warranty.If you give us such notice, we will use our
            reasonable endeavours to assist you to make a claim under the
            Product Warranty. You are responsible for the cost of returning any
            non–Nube iO branded product for repair or replacement under a
            Product Warranty including labour costs, freight, taxes and any
            other direct or indirect cost.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            If there is a manufacturing defect with a SIM Card we supply you, we
            will replace the SIM Card free of charge or refund you the cost of
            the SIM Card.
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Nube iO is not an SIM/mobile data carrier and does not supply 4G
            network carriage services. We are a reseller and may arrange for you
            to be supplied with carriage services by a carrier or a carriage
            service provider. Accordingly, you acknowledge and agree that:
          </p>
          <ul className="list-inside list-disc text-base font-light text-gray-400 mb-6">
            <li>
              We are not responsible for any act or omission of any carrier or
              carriage service provider who we arrange to supply carriage
              services to you; and
            </li>
            <li>
              We are not responsible for any interruption in, disruption to or
              suspension by a carrier or carriage service provider of the
              carriage services supplied to you.
            </li>
          </ul>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Enviro Building Services: 11 130 324 748
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Address: Unit 1, 17 Cemetery Road, Helensburgh NSW 2508 Australia
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Telephone: +612 4294-8003
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Email: accounts@nube-io.com
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Nube iO Operations: 18 629 763 177
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Address: Unit 1, 17 Cemetery Road, Helensburgh NSW 2508 Australia
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Telephone: +612 7906 8414
          </p>
          <p className="text-base font-light text-gray-400 leading-relaxed mb-6">
            Email: accounts@nube-io.com
          </p>
        </div>
        <div className="my-6 w-full border-t-2  border-theme-teal dark:border-gray-300 mb-12 mt-12" />
      </div>
    </section>
  );
}
